import { VolunteerInterface } from "../../models/resume/volunteerInterface";
/*@Todo Update your volunteer experience on your resume.
   - Remove this section entirely by deleting it on pages/resume.tsx
   - Use this section to share awards, clubs, etc. by updating the heading in pages/resume/volunteering/volunteering.tsx
   - This page is designed for three items/experiences. You may need to update the styling if you change the number
     of items on the page.
*/
export const volunteerInfo: VolunteerInterface[] =
[
    {
        id: 0,
        organization: "Organization Name",
        organizationURL: "Organization URL",
        title: "Title/Work at the org",
        startDate: "Month YYYY",
        endDate: "Month YYYY or present",
    },
    {
        id: 1,
        organization: "Organization Name",
        organizationURL: "Organization URL",
        title: "Title/Work at the org",
        startDate: "Month YYYY",
        endDate: "Month YYYY or present",
    },
    {
        id: 2,
        organization: "Organization Name",
        organizationURL: "Organization URL",
        title: "Title/Work at the org",
        startDate: "Month YYYY",
        endDate: "Month YYYY or present",
    },
]